<!-- 保卫人员选择面板 -->
<template>
  <div class="security-select-wrap">
    <el-dialog title="新增"
               :visible.sync="showPanel"
               width="650px"
               v-dialogDrag
               :modal="false"
               class="dialog"
               @close="close">
      <div class="content">
        <div class="content-top">
          <div class="content-top-left active-border-color">
            <h4 class="title">保卫账户列表</h4>
            <el-input placeholder="请输入账户名称"
                      v-model="account"
                      clearable
                      class="input-with-select"
                      style="width: 95%;margin: 10px 0">
              <el-button slot="append"
                         icon="el-icon-search"></el-button>
            </el-input>
            <ul class="group-list">
              <el-tree class="tree-list"
                       ref="tree"
                       node-key="code"
                       :data="treeData"
                       :props="props"
                       :renderContent="renderContent"
                       :filter-node-method="filterNode"
                       show-checkbox>
              </el-tree>
            </ul>
          </div>
          <div class="content-top-middle">
            <el-button class="to-left"
                       plain
                       icon="el-icon-arrow-right"
                       circle
                       size="medium"
                       @click="transferPerson('left')"></el-button>
            <el-button class="to-right"
                       plain
                       icon="el-icon-arrow-left"
                       circle
                       size="medium"
                       @click="transferPerson('right')"></el-button>
          </div>
          <div class="content-top-right active-border-color">
            <h4 class="title">已选保卫人员</h4>
            <ul class="person-list">
              <li v-for="(item, index) in selectedList"
                  :key="index"
                  class="person">
                <el-checkbox v-model="item.checked"></el-checkbox>
                <span class="checked-name"
                      :title="item.name">{{ item.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer">
          <el-button type="primary"
                     @click="submit">确 定</el-button>
          <el-button @click="close">取 消</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { api } from '../api'
import { Cache } from '$utils'
export default {
  watch: {
    account (val) {
      this.$refs.tree.filter(val);
    }
  },
  components: {},
  props: {
    workGroupCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showPanel: false,
      childrenDataList: [],
      props: {
        label: "name",
        // children: "children",
        id: "code",
        isLeaf: "isLeaf"
      },
      treeData: [],
      selectedList: [],
      //判断是否已经开始懒加载
      isLoadNode: false,
      account: '',
      workGroupList: []
    }
  },

  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
  },

  created () { },

  mounted () {

  },

  beforeDestory () { },

  methods: {
    check (value) {
      this.$nextTick(() => {
        if (!value.isLeaf && !value.children.length) {
          let param = { "accountGroupCode": value.code };
          this.$fetch(api.reserve.queryAccountGroup, param).then(res => {
            if (res.success) {
              if (res.returnObj && res.returnObj.length) {
                this.childrenDataList = res.returnObj.map(item => {
                  return {
                    code: item.accountNumber,
                    name: `${item.nickName}(${item.accountNumber})`,
                    isLeaf: true
                  }
                })
              } else {
                this.childrenDataList = [];
              }
              this.$set(value, 'children', this.childrenDataList);
            } else {
              this.$message.error(res.msgContent);
            }
          })
        }
      })
    },
    open (data) {
      console.log(data, "负责人2")
      this.showPanel = true;
      this.getRlatAccountGroup();
      this.getInList()
      this.selectedList = data ? data.map(item => {
        return {
          code: item.code,
          name: `${item.name}`,
          checked: true
        }
      }) : []
      console.log(this.selectedList, "选中负责人3")
    },
    // 获取当前不在当前保卫工作组保卫信息
    getRlatAccountGroup () {
      let params = {
        securityWorkGroupCode: this.workGroupCode
      }
      this.$fetch(api.queryOutSecurityInfo, params).then(res => {
        if (res.success) {
          if (res.returnObj && res.returnObj.length) {
            this.treeData = res.returnObj.map(item => {
              return {
                code: item.accountNumber,
                name: item.nickName,
                checked: false
                // children: item.accounts ? item.accounts.map(account => {
                //   return {
                //     code: account.accountNumber,
                //     name: `${account.nickName}(${account.accountNumber})`,
                //     isLeaf: true
                //   }
                // }) : []
              }
            })
          }
        } else {
          this.$message.error(res.msgContent);
        }
        // console.log(this.treeData, 'this.treeData')
      });
    },
    // 获取当前在当前保卫工作组保卫信息
    getInList () {
      let params = {
        securityWorkGroupCode: this.workGroupCode
      }
      this.$fetch(api.queryInSecurityInfo, params).then(res => {
        if (res.success) {
          if (res.returnObj && res.returnObj.length) {
            this.selectedList = res.returnObj.map(item => {
              console.log(item, '====anboa')
              return {
                code: item.accountNumber,
                // name: `${item.nickName}(${item.accountNumber})`,
                name: item.nickName,
                checked: true
              }
            })
          }
        } else {
          this.$message.error(res.msgContent);
        }
        console.log('this.selectedList', this.selectedList)
      });
    },
    // 自定义渲染节点
    renderContent (h, { node, data, store }) {
      return (
        <span class="custom-tree-node personwidth" title={node.label}>
          <span>{node.label}</span>
        </span>);
    },
    // 数组扁平化
    flattenArr (arr) {
      const self = this;
      return arr.reduce((flat, toFlatten) => {
        return flat.concat(Array.isArray(toFlatten) ? self.flattenArr(toFlatten) : toFlatten);
      }, []);
    },
    // 移动人员
    transferPerson (type) {
      if (type === "left") {
        console.log('--left---------');
        // 获取左边未选中的人员 (左侧列表勾选的)        
        let selectedPerson = this.$refs.tree.getCheckedNodes();
        // console.log('选中的节点', selectedPerson, this.selectedList)
        if (selectedPerson.length) {
          this.selectedList = this.selectedList.concat(selectedPerson);
          console.log( this.selectedList,'============ this.selectedList1111')
          let data = this.selectedList.map(item => {
            return {
              code: item.code,
              name: item.name,
              checked: true
            }
          });
          selectedPerson = selectedPerson.map(item => {
            return {
              code: item.code,
              name: item.name,
              checked: true
            }
          });
          // 人员根据账号去重          
          this.selectedList = this.reduceArr(data, "code");
           console.log(this.selectedList, '去重人员')
          // 当勾选中后改变左侧树checked的属性值
          this.treeData.forEach((item, index) => {
            selectedPerson.forEach((items) => {
              if (items.code === item.code) {
                item.checked = items.checked
              }
            })
          })

          // let leftChoose = this.treeData.filter(item => item.checked === true)
          // console.log('----leftChoose---leftChoose', leftChoose);
          // this.treeData.forEach((item, index) => {
          //   if (item.checked) {
          //     this.treeData.splice(index, leftChoose.length)
          //   }
          // })

          this.treeData = this.treeData.filter(item => item.checked === false)

          // console.log('----leftNoChoose---leftNoChoose', leftNoChoose);
        } else {
          selectedPerson = this.$refs.tree.getCheckedNodes(true);
          // this.selectedList = [];
        }

      } else if (type === "right") {
        // 移除右边已选人员
        if (this.selectedList.length) {
          let rightChoose = this.selectedList.filter(item => item.checked === true)
          this.selectedList = this.selectedList.filter(item => item.checked === false);
          this.treeData = this.treeData.concat(rightChoose)
          this.treeData = this.reduceArr(this.treeData, "code");
        } else {
          this.selectedList = [];
        }
        // console.log(this.treeData, '右 this.treeData已选人员')

      }
      console.log(this.selectedList, this.treeData, 'eeeeeeeeeeeeeeeeeeeeeeeeeee')
    },
    // 根据key对数组对象去重
    reduceArr (arr, key) {
      let obj = {};
      let newArr = arr.reduce((cur, next) => {
        obj[next[key]] ? "" : obj[next[key]] = true && cur.push(next);
        return cur;
      }, []);
      return newArr;
    },
    //点击确定按钮,对外暴露已选人员
    submit () {
      // console.log('====保存的列表----', this.selectedList);
      // console.log('====左侧的列表----', this.treeData);
      if (this.selectedList.length) {
        let chooseIds = []
        this.workGroupList = this.selectedList.filter(item => item.checked === true)
          .map(item => {
            console.log(item, '=====item')
            return {
              checked: item.checked,
              code: item.code,
              name: item.name
            }
            // this.workGroupList.push(item.name)
          });
        this.$emit("refreshData")
        console.log(this.workGroupList, '=========this.workGroupList')
        this.close();
        // let params = {
        //   accountNumberList: chooseIds,
        //   securityWorkGroupCode: this.workGroupCode
        // }
        // this.$fetch(api.addSecurityInfo, params).then(res => {
        //   if (res.success) {
        //     this.$message.success('新增保卫人员成功');
        //     this.close();
        //     this.$emit("refreshData")
        //   } else {
        //     this.$message.error(res.msgContent);
        //   }
        // });
      } else {
        this.$message.warning('请选择人员名单');
      }
    },
    close () {
      this.showPanel = false;
      this.selectedList.length = 0;
      this.account = ''
    },
    // 懒加载节点
    loadNode (node, resolve) {
      if (node.data && node.data.code) {
        let accountGroupCode = node.data.code;
        // 获取当前账户组关联的人员
        this.$fetch(api.reserve.queryAccountGroup, { accountGroupCode }).then(res => {
          if (res.success) {
            if (res.returnObj && res.returnObj.length) {
              let childrenData = res.returnObj.map(item => {
                return {
                  code: item.accountNumber,
                  name: `${item.nickName}(${item.accountNumber})`,
                  isLeaf: true
                }
              })
              this.$set(node.data, 'children', childrenData);
              resolve(childrenData);
              // this.childrenDataList = childrenData;
            } else {
              return resolve([]);
            }
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        return resolve([]);
      }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
  }
}
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.security-select-wrap {
  .content {
    &-top {
      display: flex;
      justify-content: space-around;
      align-content: space-around;
      text-align: center;
      padding-bottom: 30px;
      &-left,
      &-right {
        width: 48%;
        height: 350px;
        border-width: 1px;
        border-style: solid;

        h2 {
          background-color: rgba(38, 43, 55, 1);
          margin-bottom: 0;
        }
        .account {
          line-height: 24px;
          padding: 0 10px;
          text-align: left;
        }
        .group-list {
          height: calc(100% - 90px);
          overflow-y: scroll;
        }
        .person-list {
          text-align: left;
          padding: 5px 10px;
          height: calc(100% - 36px);
          overflow-y: scroll;
          .person {
            padding: 5px 0px;
            color: #b9c3d9;
            font-size: 14px;
            .name-icon {
              margin: 0 5px;
            }
            .checked-name {
              display: inline-block;
              max-width: 140px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      &-middle {
        .to-left {
          margin: 100px 0px 10px 0px;
          background: transparent;
        }
        .to-right {
          margin-left: 2px;
          background: transparent;
        }
      }
    }
  }
  .dialog {
    .el-dialog__body {
      padding: 30px;
    }
  }
  .footer {
    text-align: right;
    padding: 20px 20px 20px 0;
  }
  .title {
    height: 36px;
    line-height: 36px;
    font-weight: normal;
  }
  .tree-list .personwidth {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #b9c3d9;
  }
  .tree-list .el-tree .is-current > .el-tree-node__content,
  .tree-list .el-tree-node__content:hover {
    background-color: transparent;
  }
  .person-list .el-checkbox__input.is-checked + .el-checkbox__label {
    // color: #c9d5ec;
  }
  .expand {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 2px;
    border: 1px solid #b3cbf1;
  }
}
</style>